import { render, staticRenderFns } from "./themegj-index.vue?vue&type=template&id=2db1d23d&"
import script from "./themegj-index.vue?vue&type=script&lang=js&"
export * from "./themegj-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports